<template>
	<div :id="id" class="c-checklist-block-item" :key="index">
		<div class="c-checklist-block-item__step-container">
			<div class="c-checklist-block-item__step-icon">
				<span class="c-checklist-block__item-step-number">
					{{ order }}
				</span>
			</div>
		</div>
		<div class="c-checklist-block-item__content">
			<div class="c-checklist-block-item__card">
				<div class="c-checklist-block-item__card-icon">
					<v-icon :name="icon" size="m" />
				</div>
				<div class="c-checklist-block-item__card-content">
					<div class="c-checklist-block-item__card-header">
						<h3 class="c-checklist-block-item__card-title">
							{{ title }}
						</h3>
					</div>
					<div class="c-checklist-block-item__card-body">
						<p class="c-checklist-block-item__card-text text">
							{{
								description.length > 139
									? description.substring(0, 139) + "..."
									: description
							}}
						</p>
						<a
							v-if="linkUrl"
							:href="linkUrl"
							class="c-checklist-block-item__link-wrapper"
						>
							<span class="c-checklist-block-item__link-text">{{
								linkText
							}}</span>
							<v-icon name="icon-chevron" size="xs" />
						</a>
					</div>
				</div>
				<div class="c-checklist-block-item__checkbox">
					<button
						class="c-checklist-block-item__checkbox-button"
						:id="`${checkBoxName}-checklist-checkbox-${id}`"
						:checked="isChecked"
						@click="onCheckboxChange"
					>
						<svg
							class="c-checklist-block-item__checkbox-icon"
							:class="{
								'c-checklist-block-item__checkbox-icon--checked': isChecked
							}"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
						>
							<path
								d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,1.87A10.13,10.13,0,1,0,22.13,12,10.14,10.14,0,0,0,12,1.87Z"
							/>
							<path
								d="M10.75,17.12a.77.77,0,0,1-.53-.21L5.87,12.75A.78.78,0,1,1,7,11.63l3.79,3.62,7-7.12a.78.78,0,1,1,1.11,1.09l-7.5,7.67A.79.79,0,0,1,10.75,17.12Z"
							/>
						</svg>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
import VuexStore from "../../js/vuex-store/vuex-store.js";

export default {
	name: "VChecklistBlockItem",
	components: {
		VIcon
	},
	props: {
		id: {
			type: String
		},
		index: {
			type: Number
		},
		icon: {
			type: String
		},
		order: {
			type: Number
		},
		checkBoxName: {
			type: String,
			default: "default"
		},
		title: {
			type: String
		},
		description: {
			type: String
		},
		linkUrl: {
			type: String,
			default: null
		},
		linkText: {
			type: String,
			default: "Läs mer"
		}
	},
	data() {
		return {
			checked: []
		};
	},
	computed: {
		isChecked() {
			return this.checked.includes(String(this.id));
		}
	},

	created() {
		this.checked = this.getCheckedItemsFromLocalStorage();
	},
	methods: {
		getCheckedItemsFromLocalStorage() {
			return JSON.parse(localStorage.getItem(`${this.checkBoxName}-checklist`)) || [];
		},
		onCheckboxChange(event) {
			const checkedId = this.checked.find(ids => ids === this.id);
			this.checked = this.getCheckedItemsFromLocalStorage();

			this.$store.commit(
				"checklist/setShowModal",
				!checkedId ? String(this.id) : null
			);

			if (!checkedId) {
				this.checked = ([...this.checked, this.id]);
			} else {
				this.checked = this.checked.filter(value => value !== this.id);
			}

			localStorage.setItem(`${this.checkBoxName}-checklist`, JSON.stringify(this.checked));

			VuexStore.commit(
				"checklist/setCountCurrentChecks",
				String(this.checked.length)
			);
			this.$emit("datatoparent");
		}
	}
};
</script>
